$(document).ready(function(){
  $(document).scroll()
})

$(window).scroll(function() {
  var scroll = Math.floor($(document).scrollTop() + $(window).height());
  var maxScroll = 960;
  if($('.scroll-buttons-container').closest('.page-letter-recipient').length > 0){
    if($('.scroll-buttons-container').outerHeight() > 150) {
      maxScroll = 500 * $('.recipient-card').length - 80;
    } else {
      maxScroll = 405 * $('.recipient-card').length;
    }
  }
  if (scroll <= maxScroll) {
    $(".scroll-buttons-container").addClass('colored');
  } else {
    $(".scroll-buttons-container").removeClass("colored");
  }
});